import type { DefaultError, UseMutationOptions } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useRestoreFilesMutation(
  options?: UseMutationOptions<unknown, DefaultError, number[]>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileIds: number[]) =>
      apiClient
        .url("/my-files/restore")
        .post({
          fileIds: fileIds,
        })
        .res(),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["myFilesStructure"] });
    },
    ...options,
  });
}
